import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import axios from 'axios';
import Counter from '../../components/Counter';
import Button from '../../components/Button';

import contactBG from '../../assets/img/contact/contact-bg-3-1.jpg';

const Donation = () => {
  const formRef = useRef();

  // Counters
  const counters = [
    { countNum: 180, countSubtext: '+', countTitle: 'Total Doctors' },
    { countNum: 1150000, countSubtext: '+', countTitle: 'Happy Patients' },
    { countNum: 14, countSubtext: '+', countTitle: 'Years of Experience' },
    { countNum: 120, countSubtext: '+', countTitle: 'Total Rooms' },
  ];

  // Submit both to EmailJS and PHP backend
const handleSubmit = async (e) => {
  e.preventDefault();

  const form = formRef.current;
const formData = {
  name: form.name.value.trim(),
  email: form.email.value.trim(),
  phone: form.phone.value.trim(),
  message: form["Any Message"].value.trim(),
  donation_date: form.donation_date.value.trim(), // ✅ new field
};

  try {
    const res = await axios.post('http://ricgop.online/api/blooddonation.php', formData, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (res.data?.message === "Query submitted successfully") {
      console.log('Saved to database!');
      alert('Your query has been submitted.');
      form.reset();
    } else {
      console.error('API error:', res.data);
      alert('Submission failed, please try again.');
    }
  } catch (err) {
    console.error('DB save failed', err);
    alert('Server error occurred.');
  }

    // Submit via EmailJS
    emailjs
      .sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form, {
        publicKey: 'YOUR_PUBLIC_KEY',
      })
      .then(
        () => {
          console.log('Email sent!');
          form.reset();
        },
        (error) => {
          console.log('Email send failed...', error.text);
        }
      );
  };

  return (
    <div
      className="it-contact-area it-contact-overley it-contact-style-2 z-index pt-120 mb-165"
      style={{ backgroundImage: `url(${contactBG})` }}
    >
      <div id="it-contact" className="container">
        <div className="row align-items-end">
          <div className="col-xxl-5 col-xl-6 col-lg-6">
            <div className="it-contact-item">
              <h4 className="it-contact-title mb-60">
                Get support For any Queries or Complaints
              </h4>
              <div className="row">
                {counters.map((counter, index) => (
                  <div
                    key={index}
                    className="col-lg-6 col-md-4 col-6 col-sm-6 mb-10"
                  >
                    <div className="it-funfact-item">
                      <h5 className="it-funfact-number">
                        <Counter
                          start={0}
                          end={counter.countNum}
                          duration={3}
                          counterSubText={counter.countSubtext}
                        />
                      </h5>
                      <span className="it-funfact-title">
                        {counter.countTitle}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-xxl-7 col-xl-6 col-lg-6">
            <div className="it-contact-from-wrap z-index">
              <h4 className="it-contact-title text-black mb-10">
                Send Your Blood Query To Us
              </h4>
              <div className="it-contact-text mb-40">
                <p>Just 1 pint of your blood can save up to 3 lives. Be a hero today — it takes only 15 minutes!</p>
              </div>

              <form ref={formRef} onSubmit={handleSubmit}>
                <div className="row gx-20">
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="text" name="name" placeholder="Full Name" required />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="email" name="email" placeholder="E-mail Address" required />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                      <input type="text" name="phone" placeholder="Phone Number" />
                    </div>
                  </div>
                  <div className="col-md-6 col-12 mb-20">
                    <div className="it-contact-input-box">
                        <input type="date" name="donation_date" placeholder="Preferred Donation Date" required />
                    </div>
                  </div>
                  <div className="col-12 mb-30">
                    <div className="it-contact-input-box">
                      <textarea name="Any Message" placeholder="Your Message" required></textarea>
                    </div>
                  </div>
                </div>
                <button type="submit" className="it-btn-theme tertiary-bg">
                  <Button btnText="Submit Your Blood" />
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Donation;
